(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sts-support-chat"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-sts-support-chat]').forEach((root) => {
      const launcher = root.querySelector('[data-sts-support-launcher]');
      const panel = root.querySelector('[data-sts-support-panel]');
      const close = root.querySelector('[data-sts-support-close]');
      const form = root.querySelector('[data-sts-support-form]');
      const input = root.querySelector('[data-sts-support-input]');
      const messages = root.querySelector('[data-sts-support-messages]');
      const submit = form?.querySelector('button[type="submit"]');
      const endpoint = String(root.dataset.serviceUrl || '').trim().replace(/\/+$/, '');
      const sessionKey = 'stsSupportConversationId';
      let welcomeShown = false;

      if (!launcher || !panel || !close || !form || !input || !messages || !submit) return;

      const addMessage = (text, sender) => {
        const message = document.createElement('div');
        message.className = `sts-support-chat__message sts-support-chat__message--${sender}`;
        message.textContent = text;
        messages.appendChild(message);
        messages.scrollTop = messages.scrollHeight;
        return message;
      };

      const showWelcome = () => {
        if (welcomeShown) return;
        addMessage(root.dataset.welcome || '', 'assistant');
        welcomeShown = true;
      };

      const openPanel = () => {
        panel.hidden = false;
        launcher.setAttribute('aria-expanded', 'true');
        if (window.matchMedia('(max-width: 639px)').matches) document.body.classList.add('sts-support-chat-open');
        showWelcome();
        window.setTimeout(() => input.focus(), 50);
      };

      const closePanel = () => {
        panel.hidden = true;
        launcher.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('sts-support-chat-open');
        launcher.focus();
      };

      const parseStream = async (response, output) => {
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = '';
        let answer = '';

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, { stream: true });
          const events = buffer.split('\n\n');
          buffer = events.pop() || '';

          events.forEach((event) => {
            event.split('\n').forEach((line) => {
              if (!line.startsWith('data: ')) return;
              try {
                const data = JSON.parse(line.slice(6));
                if (data.type === 'id' && data.conversation_id) sessionStorage.setItem(sessionKey, data.conversation_id);
                if (data.type === 'chunk' && data.chunk) {
                  answer += data.chunk;
                  output.textContent = answer;
                  messages.scrollTop = messages.scrollHeight;
                }
              } catch (error) {
                console.warn('Stone Tech support received an unreadable response.', error);
              }
            });
          });
        }

        if (!answer) output.textContent = root.dataset.fallback || '';
      };

      const sendMessage = async (text) => {
        const clean = String(text || '').trim();
        if (!clean) return;
        addMessage(clean, 'user');
        input.value = '';
        submit.disabled = true;

        if (!endpoint) {
          addMessage(root.dataset.fallback || '', 'assistant');
          submit.disabled = false;
          return;
        }

        const output = addMessage(root.dataset.thinking || '', 'assistant');
        try {
          const response = await fetch(`${endpoint}/chat`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'text/event-stream',
              'X-Shopify-Shop-Id': root.dataset.shopId || ''
            },
            body: JSON.stringify({
              message: clean,
              conversation_id: sessionStorage.getItem(sessionKey),
              prompt_type: 'stoneTechAssistant'
            })
          });

          if (!response.ok || !response.body) throw new Error(`Assistant service returned ${response.status}`);
          output.textContent = '';
          await parseStream(response, output);
        } catch (error) {
          console.error('Stone Tech support request failed.', error);
          output.textContent = root.dataset.fallback || '';
        } finally {
          submit.disabled = false;
          input.focus();
        }
      };

      launcher.addEventListener('click', () => panel.hidden ? openPanel() : closePanel());
      close.addEventListener('click', closePanel);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        sendMessage(input.value);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
          event.preventDefault();
          form.requestSubmit();
        }
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) closePanel();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-scripts"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  document.addEventListener('click', (event) => {
    const disclosure = event.target.closest('details[data-close-on-link]');
    if (disclosure && event.target.closest('a')) disclosure.removeAttribute('open');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
  });

  const header = document.querySelector('[data-site-header]');
  if (header) {
    const updateHeader = () => header.toggleAttribute('data-scrolled', window.scrollY > 24);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const normalizeFinderList = (value) => value
    .split(',')
    .map((item) => item.trim().toLowerCase().replace(/\s+/g, '-'))
    .filter(Boolean);

  document.querySelectorAll('[data-blade-finder]').forEach((finder) => {
    const form = finder.querySelector('[data-finder-form]');
    const steps = [...finder.querySelectorAll('[data-finder-step]')];
    const progressItems = [...finder.querySelectorAll('[data-finder-progress]')];
    const progressLabel = finder.querySelector('[data-finder-progress-label]');
    const nextButton = finder.querySelector('[data-finder-next]');
    const backButton = finder.querySelector('[data-finder-back]');
    const submitButton = finder.querySelector('[data-finder-submit]');
    const restartButton = finder.querySelector('[data-finder-restart]');
    const output = finder.querySelector('[data-finder-output]');
    const emptyTemplate = finder.querySelector('[data-finder-empty-template]');
    const matches = [...finder.querySelectorAll('template[data-finder-match]')];
    let currentStep = 1;

    if (!form || steps.length === 0) return;

    const updateStep = (step) => {
      currentStep = Math.max(1, Math.min(3, step));
      steps.forEach((panel) => { panel.hidden = Number(panel.dataset.finderStep) !== currentStep; });
      progressItems.forEach((item) => {
        const itemStep = Number(item.dataset.finderProgress);
        item.dataset.active = String(itemStep === currentStep);
        item.dataset.complete = String(itemStep < currentStep);
      });
      if (progressLabel) progressLabel.textContent = `Step ${currentStep} of 3`;
      backButton.hidden = currentStep === 1;
      nextButton.hidden = currentStep === 3;
      submitButton.hidden = currentStep !== 3;
      restartButton.hidden = true;
      output.hidden = true;
    };

    const validateCurrentStep = () => {
      const firstInput = form.querySelector(`[data-finder-step="${currentStep}"] input`);
      const selected = form.querySelector(`[data-finder-step="${currentStep}"] input:checked`);
      if (selected) return true;
      if (firstInput) firstInput.reportValidity();
      return false;
    };

    nextButton.addEventListener('click', () => {
      if (validateCurrentStep()) updateStep(currentStep + 1);
    });
    backButton.addEventListener('click', () => updateStep(currentStep - 1));

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!validateCurrentStep()) return;

      const data = new FormData(form);
      const material = String(data.get('material') || '');
      const machine = String(data.get('machine') || '');
      const diameter = String(data.get('diameter') || '');
      const compatible = matches
        .filter((template) => normalizeFinderList(template.dataset.materials).includes(material))
        .filter((template) => normalizeFinderList(template.dataset.machines).includes(machine))
        .filter((template) => normalizeFinderList(template.dataset.diameters).includes(diameter))
        .sort((a, b) => Number(b.dataset.priority) - Number(a.dataset.priority));

      output.replaceChildren((compatible[0] || emptyTemplate).content.cloneNode(true));
      output.hidden = false;
      steps.forEach((panel) => { panel.hidden = true; });
      nextButton.hidden = true;
      backButton.hidden = true;
      submitButton.hidden = true;
      restartButton.hidden = false;
      if (progressLabel) progressLabel.textContent = compatible.length ? 'Verified match' : 'Specialist check required';
      progressItems.forEach((item) => { item.dataset.complete = 'true'; item.dataset.active = 'false'; });
      output.querySelector('a, button')?.focus();
      const liveRegion = document.querySelector('[data-live-region]');
      if (liveRegion) liveRegion.textContent = compatible.length ? 'A verified blade match is ready.' : 'No automatic match was found. Technical support is recommended.';
    });

    restartButton.addEventListener('click', () => {
      form.reset();
      output.replaceChildren();
      updateStep(1);
      form.querySelector('input')?.focus();
    });

    updateStep(1);
  });

  document.querySelectorAll('[data-sts-blade-finder]').forEach((finder) => {
    const form = finder.querySelector('[data-sts-finder-form]');
    const output = finder.querySelector('[data-sts-finder-output]');
    const emptyTemplate = finder.querySelector('[data-sts-finder-empty-template]');
    const matches = [...finder.querySelectorAll('template[data-sts-finder-match]')];
    if (!form || !output || !emptyTemplate) return;

    const renderMatch = () => {
      const data = new FormData(form);
      const material = String(data.get('material') || '');
      const machine = String(data.get('machine') || '');
      const diameter = String(data.get('diameter') || '');

      const ranked = matches
        .map((template) => {
          const materials = normalizeFinderList(template.dataset.materials);
          const machines = normalizeFinderList(template.dataset.machines);
          const diameters = normalizeFinderList(template.dataset.diameters);
          const compatible = materials.includes(material) && machines.includes(machine) && diameters.includes(diameter);
          const score = Number(template.dataset.priority) + (materials.length === 1 ? 20 : 0) + (diameters.includes(diameter) ? 15 : 0);
          return { template, compatible, score };
        })
        .filter((match) => match.compatible)
        .sort((a, b) => b.score - a.score);

      output.replaceChildren((ranked[0]?.template || emptyTemplate).content.cloneNode(true));
      const liveRegion = document.querySelector('[data-live-region]');
      if (liveRegion) liveRegion.textContent = ranked.length ? 'A verified blade match is ready.' : 'No verified automatic match was found. Talk to a Stone Tech blade specialist before ordering.';
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      renderMatch();
    });
    form.querySelectorAll('[data-sts-finder-select]').forEach((select) => select.addEventListener('change', renderMatch));
    renderMatch();
  });

  const applicationLabels = {
    'porcelain-ucs-quartzite': 'Porcelain, UCS & Quartzite',
    granite: 'Granite',
    marble: 'Marble',
    'engineered-quartz': 'Engineered Quartz',
    concrete: 'Concrete & Construction'
  };

  document.querySelectorAll('[data-application-filter]').forEach((collectionSection) => {
    const selectedApplication = new URLSearchParams(window.location.search).get('application');
    if (!selectedApplication || !applicationLabels[selectedApplication]) return;

    const cards = [...collectionSection.querySelectorAll('.product-card[data-applications]')];
    const status = collectionSection.querySelector('[data-application-filter-status]');
    const emptyState = collectionSection.querySelector('[data-application-filter-empty]');
    const toolbarCount = collectionSection.querySelector('[data-collection-count]');
    const formInput = collectionSection.querySelector('[data-application-filter-input]');
    let visibleCount = 0;

    cards.forEach((card) => {
      const applications = normalizeFinderList(card.dataset.applications || '');
      const isVisible = applications.includes(selectedApplication);
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (formInput) {
      formInput.name = 'application';
      formInput.value = selectedApplication;
    }
    if (status) {
      status.hidden = false;
      status.querySelector('[data-application-filter-count]').textContent = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;
      status.querySelector('[data-application-filter-label]').textContent = applicationLabels[selectedApplication];
    }
    if (toolbarCount) toolbarCount.textContent = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;
    if (emptyState) emptyState.hidden = visibleCount !== 0;

    collectionSection.querySelectorAll('.pagination a').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('application', selectedApplication);
      link.href = url.toString();
    });

    const liveRegion = document.querySelector('[data-live-region]');
    if (liveRegion) liveRegion.textContent = `${visibleCount} products shown for ${applicationLabels[selectedApplication]}.`;
  });
  } catch(e) { console.error(e); }
})();

})();
